import { Dispatch } from "react";
import { apiBaseUrl, networkCall } from "../../utils/networkCall";

export const DELETE_API_RESPONSE = "DELETE_API_RESPONSE";
export const BULK_API_RESPONSE = "BULK_API_RESPONSE";
export const BULK_DELETE_API_RESPONSE = "BULK_DELETE_API_RESPONSE";


export function getDeleteAPIResponse(res: any): IDeleteUrlActionType {
    return { type: DELETE_API_RESPONSE, deleteResponse: res };
}

export function getBulkDeleteAPIResponse(res: any): IDeleteUrlActionType {
    return { type: BULK_DELETE_API_RESPONSE, deleteResponse: res };
}

export function getBulkListAPIResponse(res: any): IBulkListUrlActionType {
    return { type: BULK_API_RESPONSE, response: res };
}

export const deleteUrl = (id: string, appid: string, callback: (resp: any, flag: boolean) => void) => {
    return (dispatch: Dispatch<any>) => {
        networkCall('delete', `/txtly/delete?id=${id}&appid=${appid}`, apiBaseUrl.baseUrl)
            .then((response: any) => {
                dispatch(getDeleteAPIResponse(response));
                callback(response, true)
            })
            .catch((err: any) => {
                console.log(err)
                callback(err, false)
            })
    }
}

export const bulkDeleteUrl = (id: string, appid: string, callback: (resp: any, flag: boolean) => void) => {
    return (dispatch: Dispatch<any>) => {
        networkCall('delete', `/txtly/delete-bulk?id=${id}&appid=${appid}`, apiBaseUrl.baseUrl)
            .then((response: any) => {
                dispatch(getDeleteAPIResponse(response));
                callback(response, true)
            })
            .catch((err: any) => {
                console.log(err)
                callback(err, false)
            })
    }
}

export const getBulkList = (filters?: Record<string, any>) => {
    let reqParam = "";
    if (filters) {
        reqParam = "?";
        Object.keys(filters).map((key: string, index: number) => {
            reqParam = `${reqParam}${key}=${filters[key]}`;
            if (Object.keys(filters).length - 1 > index) {
                reqParam = reqParam + "&"
            }
        })
    }
    return (dispatch: Dispatch<any>) => {
        networkCall('get', `/txtly/listbulk${reqParam}`, apiBaseUrl.baseUrl)
            .then((response: any) => {
                dispatch(getBulkListAPIResponse(response));
            })
            .catch((err: any) => {
                console.log(err)
            })
    }
}

interface IDeleteUrlActionType {
    type: string,
    deleteResponse: any
}
interface IBulkListUrlActionType {
    type: string,
    response: any
}